import React from "react"

const BaseFilterContext = React.createContext({isShowFilter: true, setIsShowFilter: null})

export {BaseFilterContext}
